const SCRIPT_UNSAFE = /[<>&\u2028\u2029]/g;

export function scriptJson(value: unknown): string {
  return JSON.stringify(value).replace(SCRIPT_UNSAFE, (character) =>
    `\\u${character.charCodeAt(0).toString(16).padStart(4, "0")}`);
}
